import callApi from './personnelService';

const basePath = `/frontend/api/one-to-one/${process.env.VUE_APP_COMPANY_KEY}/profile`;

export const changeProfilePreferredName = (formData) => callApi({
    method: 'POST',
    endpoint: `${basePath}/change-name`,
    body: formData
});
export const changeProfileAutoReplyMessage = (formData) => callApi({
    method: 'POST',
    endpoint: `${basePath}/change-reply-message`,
    body: formData
});
export const changeProfile = (formData) => callApi({
    method: 'POST',
    endpoint: `${basePath}/change-profile`,
    body: formData
});
